// SignUpCTA.tsx
import React from "react";
import Alert from "@mui/material/Alert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Button from "@mui/material/Button";
import ReactRouterLink from "./ReactRouterLink";
import Footer from "./Footer";

const SignUpSection: React.FC = () => {
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff4e5",
          padding: "20px",
          borderRadius: "16px",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <Alert
          severity="warning"
          icon={<InfoOutlinedIcon />}
          style={{ marginBottom: "0px", borderRadius: "16px" }}
        >
          Ready to sell your toys hassle-free? Check out FiddlePiddle.com. No
          listing or joining fees, just sign up with your email and password,
          and start earning instantly! Say goodbye to Amazon and eBay
          frustrations. Give it a go, it's that easy!
        </Alert>
        <center style={{ marginTop: "-20px" }}>
          <div style={{}}>
            <h4>Free to Join • Free to List • Instant Payout*</h4>
            <ReactRouterLink
              to="/blog/start-selling-on-fiddlepiddlecom"
              isLinkUnderline={false}
              linkElement={
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    borderRadius: "20px",
                    width: "200px",
                    color: "white",
                    lineHeight: "unset",
                  }}
                  sx={{ marginTop: "-10px" }}
                >
                  Start Selling Now
                </Button>
              }
            />
          </div>
        </center>
      </div>
      <div style={{ marginBottom: 20 }}>
        <Footer />
      </div>
    </>
  );
};

export default SignUpSection;
